import React from "react";
import Flagship from "../../core/flagship";
import UserField from "../misc/UserField";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon } from "semantic-ui-react";

class IoProductAssignModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.assigneeData = {
      first_name: this.props.data.first_name,
      last_name: this.props.data.last_name,
      id: this.props.data.user_id,
      photo: this.props.data.photo,
      username: this.props.data.username,
      email: this.props.data.email,
      phone: this.props.data.phone
    };
  }

  getInitialState() {
    return {
      assignee: this.props.data.user_id,
      assigneeName: this.props.data.first_name + " " + this.props.data.last_name
    };
  }

  onChange(e, data) {
    let assigneeName = "";

    if (typeof data.options !== "undefined" && data.options.length > 0) {
      data.options.map(function(item) {
        if (item.value === data.value) {
          assigneeName = item.text;
        }
      });

      this.setState({
        assignee: data.value,
        assigneeName
      });
    }
  }

  saveAndExit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    const newAssignee = this.state.assignee;
    const newAssigneeName = this.state.assigneeName;
    let self = this;
    Flagship.post(
      "io-product/assign/" + self.props.data.id,
      {
        assignee: this.state.assignee,
        assignedName: this.state.assigneeName
      },
      function(response) {
        if (response.data.success === true) {
          Flagship.sendMail(
            "update-io-product-assignee",
            {
              ioProductId: self.props.data.id,
              ioProductKey: self.props.data.io_product_key,
              ioProductName: self.props.data.io_product_name,
              oldAssignee: self.props.data.user_id,
              newAssignee: self.state.assignee
            },
            self.props.recordId,
            self.props.userId
          );

          Flagship.event(
            "update-io-product-assignment",
            {
              ioProductId: self.props.data.id,
              ioProductKey: self.props.data.io_product_key,
              ioProductName: self.props.data.io_product_name,
              oldAssignee: self.props.data.user_id,
              newAssignee: self.state.assignee
            },
            self.props.recordId,
            self.props.userId
          );
          Flagship.notify("IO product assigned.");
          self.setState(self.getInitialState(), function() {
            // Subscribe user to parent IO
            Flagship.post(
              "subscribe/" + self.props.recordId + "/" + response.data.user_id,
              {},
              function(responseSub) {

                if (responseSub.data.success === true) {
                  self.props.onChangeAssignee();
                  Flagship.notify(
                    "Subscribed new assignee to parent IO.",
                    "info"
                  );
                  Flagship.log("auto-subscribe-user", JSON.stringify({userId: newAssignee, userName: newAssigneeName, ioProductKey: self.props.data.io_product_key, ioProductName: self.props.data.io_product_name}), self.props.recordId, null);
                } else {
                  Flagship.error(
                    "Failed to add as a subscriber.",
                    self.props.data.id,
                    self.state.assignee
                  );
                }
              }
            );

            if (typeof self.props.onUpdateIoProduct === "function") {
              self.props.onUpdateIoProduct();
            }
          });
        } else {
          Flagship.error(
            "Error updating IO product assignee.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error updating IO product assignee: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  render() {
    let self = this;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.cancelUpdate}
        closeIcon
        closeOnDimmerClick={false}
      >
        <Header
          icon="pin"
          content={
            this.props.data.io_product_key +
            " - " +
            this.props.data.io_product_name
          }
        />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <UserField
                  label="Assigned User"
                  userData={this.assigneeData}
                  selectedUser={this.state.assignee}
                  onChange={(e, data) => self.onChange(e, data)}
                />
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveAndExit}>
            <Icon name="plus" /> Update IO Product
          </Button>
          <Button color="grey" onClick={this.props.cancelUpdate}>
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(IoProductAssignModal);



// WEBPACK FOOTER //
// ./src/components/modals/IoProductAssignModal.js